import webSDKCore from '@tencent/ti18n-websdkcore';
import { language } from '@tencent/ppd-base-libs';
import { isObject, isFunction } from '@tencent/ppd-base-libs/type';
import zh from './zh-cn/main.json';
import en from './en/main.json';

// 初始化webSDKCore
webSDKCore.init({
  ns: ['home'], // 命名空间
  defaultNS: ['home'], // 默认命名空间
  fallbackLng: ['zh-cn'], // 回退的语言，如果翻译程序执行的语言不可用的时候，回退的语言
  lng: getLanguage(),
  load: 'currentOnly',
  partialBundledLanguages: false, // 部分从sdk传入，部分从connector获取
  debug: false, // 开启调试
  cache: {
    expires: 1, // 过期时间，单位：s，默认为86400: 1天
  },
  // 导入本地资源文件
  resources: {
    'zh-cn': {
      home: zh,
    },
    en: {
      home: en,
    },
  },
});

// 格式化后的系统语言
let lang = '';

// 原始系统语言
let systemLang = '';

// 封装ti8n的翻译方法
/**
 *
 * @param key 对应的语言key
 * @param isNotTransform 是否不做转换，有一些场景的转换是通过ti18n来进行的，但是又需要保留扫描能力，所以保留了这个方式是为了能被扫描到
 * @returns
 */
export function i18n(key: string, isNotTransform = false) {
  // 原样返回，由dom来渲染
  if (isNotTransform) {
    return key;
  }
  return webSDKCore.t(key);
}

const defaultOption = {
  key: 'lang',
  defaultLang: 'en',
  keyMap: {
    // 台湾也和繁体中文一样处理
    'zh-tw': () => 'zh-hk',
    // 内地也和繁体中文一样处理
    'zh-cn': () => 'zh-hk',
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
function _getSystem() {
  if (!systemLang) {
    systemLang = language.getLangFromUa() || language.getLangFromNavigator();
  }
  console.log('系统语言', systemLang);
  return systemLang;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function _getLang(selectArr, option = {}) {
  const finalOption = Object.assign({}, defaultOption, option);
  const lang = getLang(finalOption);
  return lang;
}

function getLang({ key, keyMap }) {
  let lang = language.getLangFromUrl(key) ||  _getSystem();
  lang = formatLang(lang);
  if (isObject(keyMap) && isFunction(keyMap[lang])) {
    lang = keyMap[lang](lang);// 做映射
  }
  return lang;
}

function formatLang(lang) {
  return lang.replace(/_/g, '-').toLowerCase();
}

/**
 * 初始化语言
*/
function initLang() {
  lang = getLang({
    key: 'lang',
    keyMap: {
    },
  });
  // 如果语言以zh开头，则是否中文
  if (lang.startsWith('zh')) {
    lang = 'zh-cn';
  } else {
    lang = 'en';
  }
}

/**
 * 获取格式化后的系统语言
*/
export function getLanguage() {
  if (!lang) {
    initLang();
  }
  return lang;
}

/**
 * 获取原始系统语言
*/
export function getSystemLanguage() {
  return _getSystem();
}
